import {createSlice, PayloadAction} from '@reduxjs/toolkit';

// import {Apartment, Apartments} from 'src/apis/autoGenerate/api';
import {Apartment} from 'src/apis/autoGenerate/types/apartment';
import {RootState, store} from '../store';
// import {apartmentServiceFind} from 'src/apis';
import {apartmentServiceFind} from 'src/apis/autoGenerate/services';

export enum ApiFetchStatus {
  loading,
  idle,
  failed,
}

export interface PropertyState {
  apartmentList: Apartment[];
  loadingList: boolean;
}

const initialState: PropertyState = {
  apartmentList: [],
  loadingList: false,
};

export const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    setApartmentList: (state, action: PayloadAction<Apartment[]>) => {
      state.apartmentList = action.payload;
    },
    setLoadingList: (state, action: PayloadAction<boolean>) => {
      state.loadingList = action.payload;
    },
  },
});

export const {setApartmentList, setLoadingList} = propertySlice.actions;
export const selectProperty = (state: RootState) => state.property;

export async function getApartmentList(orgId?: string, userId?: string, forceGet = false) {
  const state = store.getState();
  const token = state.account.jwtToken; // Retrieve token from Redux

  if (!token) {
    console.error('Error: Missing authentication token.');
    return;
  }
  if (!orgId && !userId) {
    console.error('Error: Either orgId or userId must be provided.');
    return;
  }
  // ✅ Ensure apartmentList is always an array
  const apartmentList = state.property.apartmentList ?? [];

  if (apartmentList.length === 0 || forceGet) {
    store.dispatch(setLoadingList(true));
    return apartmentServiceFind(orgId, undefined, undefined, userId, {
      headers: {Authorization: `Bearer ${token}`}, // ✅ Attach token
    })
      .then(res => {
        const apartments = res.data.apartments || [];
        store.dispatch(setApartmentList(apartments));
      })
      .finally(() => {
        store.dispatch(setLoadingList(false));
      });
  }
}

export async function getApartmentById(id: string, forceGet = true) {
  const state = store.getState();
  const orgId = state.account.role?.org_id;
  const userId = state.account.userId;

  if (!orgId && !userId) {
    console.error('Error: Cannot fetch apartment, missing orgId and userId.');
    return null;
  }

  await getApartmentList(orgId, userId, forceGet); // Pass parameters

  const updatedState = store.getState();
  return updatedState.property.apartmentList.find(apartment => apartment.id === id) || undefined;
}

export default propertySlice.reducer;
